// extracted by mini-css-extract-plugin
module.exports = {"previousSelections":"WizardSelections_previousSelections__3CTIV","selections":"WizardSelections_selections__B2E0z","selection":"WizardSelections_selection__1AHCd"};